import {TokenStorageService} from "../services/token-storage.service";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export default class AuthHelper {

  private static tokenStorage: TokenStorageService

  constructor(private tokenStorage: TokenStorageService) {
    AuthHelper.tokenStorage = this.tokenStorage
  }

  public isAuthorized(): boolean {
    return this.tokenStorage.hasToken("access_token");
  }
}
